<script>
export default {
  methods: {
    changeTimeToHours (diff, timeUnits) {
      switch (timeUnits) {
        case 'YEAR':
          return diff * 8760
        case 'QUARTER':
          return diff * 2190
        case 'MONTH':
          return diff * 720
        case 'WEEK':
          return diff * 168
        case 'DAY':
          return diff * 24
        case 'MINUTE':
          return diff / 60
        case 'SECOND':
          return diff / 3600
        default:
          return diff
      }
    },
    colorBasedOnDiff (diff, timeUnits = 'HOUR') {
      const diffInHours = this.changeTimeToHours(diff, timeUnits)

      if (diffInHours < 0) return 'kbPink'

      const currentHours = new Date().getHours()
      const currentDayLeftHours = 24 - currentHours

      if (diffInHours <= currentDayLeftHours) return '#F4D35E'
      return 'kbGreen'
    },
    statusBasedOnDiff (diff, timeUnits = 'HOUR') {
      const diffInHours = this.changeTimeToHours(diff, timeUnits)

      if (diffInHours < 0) return this.$t('general.expiredTime')

      const currentHours = new Date().getHours()
      const currentDayLeftHours = 24 - currentHours

      if (diffInHours <= currentDayLeftHours) return this.$t('general.aboutToExpire')
      return this.$t('general.onTime')
    }
  }
}
</script>
